import React from 'react';
import { RetakeBanner } from '@tkww/ads-content-component-fashion-stylematch';
import styles from './styles.css';

const getQuizCompleted = () => {
  try {
    return JSON.parse(localStorage.getItem('fashion_stylematch_quiz_completed')) || false;
  } catch (error) {
    console.error('Error retrieving quiz completion status:', error);
    return false;
  }
};

const TKRetakeBanner = ({ containerClass = '', quizUrl, facadeProduct, isDesignerPage }) => {
  const quizCompleted = getQuizCompleted();

  if (facadeProduct !== 'WeddingDress' || !quizCompleted || isDesignerPage) {
    return "";
  }

  return (
    <div className={styles[containerClass]}>
      <RetakeBanner
        title="Results not feeling right?"
        subtitle="Retake quiz"
        onOpenModal={() => console.log('Open modal')}
        quizUrl={quizUrl}
      />
    </div>
  );
};

export default TKRetakeBanner;
